import React, { useState, useEffect } from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { useSelector } from 'react-redux'
import { useApp } from '../../../../../../hooks/common'
import { appendEbanxScript } from '../../credits/utils/ebanx'
import { errorEbanx } from '../../../../../../../api'
import { useCallback } from 'react'
import { BigButton } from '../../../../../../components/button'

export default props => {
    useStyles(classes)
    const { payMethod, creditOrder, onError, disabledMsg } = props
    const global = useSelector(state => state.global)
    const [dropin, setDropin] = useState(null)
    const isApp = useApp()
    const { config } = global
    const { publicKey } = config?.paykeys?.ebanx || {}
    const key = Object.keys(publicKey)?.find(key => key?.split(',')?.some(k => k === payMethod))
    const pk = publicKey?.[key]
    const order = creditOrder?.order
    const [loading, setLoading] = useState(false)


    const getBaseTheme = useCallback(() => {


        


        return {
            display: 'block',
            width: '100%',
            height: '33px',
            fontFamily: 'Roboto',
            color: '#222',
            border: 'none',
            outline: 'none',
            ':focus': {
            },
            '::placeholder': {
                color: '#999',
            },
        }
    }, [])

    useEffect(async () => {
        if(order){
            const address = order.shippingDetail || order.billingAddress
            const name = address.firstName ? `${address.firstName} ${address.lastName || ''}` : address.name
            const country = address?.country?.value
    
            const valusOptions = country === 'BR' ? {
                billingAddressCity: address?.city || '',
                billingAddressStreet: address?.streetAddress1 || '',
                billingAddressStreetNumber: address?.unit || '',
                billingAddressState: address?.state?.value || '',
                billingAddressZipcode: address?.zipCode || '',
                billingAddressComplement: '',
                customerDocument: address?.cpf || order?.shippingDetail?.cpf || '',
                customerPhoneNumber: address?.phoneNumber || '',
            } : {}

            console.log(valusOptions)
    
            await appendEbanxScript()
    
            if (window.EBANX) {
                window.EBANX.init({
                    publicIntegrationKey: pk,
                    country: country?.toLowerCase(),
                    mode: config?.env === 'sandbox' ? 'test' : 'production',
                })
    
                const _dropin = window.EBANX.dropin.create()
                _dropin.mount('#geeko-ebanx-dropin', {
                    amount: order?.orderTotal?.amount,
                    lookAndFeel: {
                        name: 'raw',
                        primaryColor: '#222',
                        theme: {
                            secureField: { base: getBaseTheme() },
                        },
                    },
                    paymentMethods: payMethod === '140' ? ['creditcard', 'debitcard'] : ['creditcard'],
                    values: {
                        customerName: name,
                        customerEmail: address.email || order.buyerEmail,
                        ...valusOptions
                    }
                })
                setDropin(_dropin)
            }
        }

    }, [order])


    const submitHandle = async e => {
        e.preventDefault()

        if (disabledMsg) {
            onError({
                message: disabledMsg
            })
            return
        }

        setLoading(true)

        try {
            const paymentData = await dropin?.handleSubmit?.(e); //object that will store teh payment information
            const isSuccess = (paymentData && paymentData.creditcard && paymentData.creditcard.token) || (paymentData && paymentData.card && paymentData.card.token)
            setLoading(false)
            if (isSuccess) {
                props.onSubmit(paymentData)
            } else {
                if (typeof paymentData === 'string') {
                    errorEbanx({ payErrorMsg: paymentData, transactionId: order.transactionId })
                }
                if (isApp) {
                    window.location.href = `/geekopay/app-fail?errMsg=${encodeURIComponent('Complete la información correcta de la tarjeta y vuelva a intentarlo.')}`
                } else {
                    onError({
                        message: 'Complete la información correcta de la tarjeta y vuelva a intentarlo.'
                    })
                }
            }
        } catch (error) {
            if (isApp) {
                window.location.href = `${window.ctx || ''}/geekopay/app-fail?errMsg=${encodeURIComponent('Complete la información correcta de la tarjeta y vuelva a intentarlo.')}`
            } else {
                onError('Complete la información correcta de la tarjeta y vuelva a intentarlo.')
            }
        }
    }

    return <form id="geeko-ebanx-dropin-form" onSubmit={submitHandle}>
        <div id="geeko-ebanx-dropin"></div>
        <BigButton loading={loading} className={classes.Submit}>Submit</BigButton>
    </form>
}